import { useContext, Fragment } from 'react'
import { Text, Icon } from '@leroy-merlin-br/backyard-react-ui'
import { Cross } from '@leroy-merlin-br/backyard-react-icons'

import { EntryKeyContext } from '../../context/EntryKeyContext'
import * as S from './styled'

const AppliedFilters = () => {
  const { onOptionClick, filterUsedOptions } = useContext(EntryKeyContext)

  return (
    <Fragment>
      <Text as="strong" size="giga" bold noMargin>
        Filtros selecionados
      </Text>

      <S.Inline align="center" justify="start" spacing="byte">
        {filterUsedOptions.map((filter, index) => (
          <S.Tag key={index}>
            <S.Label>{filter.label}</S.Label>
            <S.ButtonClose
              type="button"
              onClick={event => {
                event.preventDefault()
                event.stopPropagation()

                onOptionClick({
                  name: filter.filterKey,
                  value: filter.query.replace(/\s/g, '_'),
                  type: 'filter',
                  dataLayerOptions: {
                    filter: 'Normal',
                    filterType: {
                      index: filter.filterTypeIndex,
                      value: filter.name
                    },
                    filterElement: {
                      index: filter.filterElementIndex,
                      value: filter.label
                    }
                  }
                })
              }}
            >
              <Icon as={Cross} size="byte" color="white" />
            </S.ButtonClose>
          </S.Tag>
        ))}
      </S.Inline>
    </Fragment>
  )
}

export default AppliedFilters
